import { render } from "./ComposeGroup.vue?vue&type=template&id=68f0a3dd&scoped=true"
import script from "./ComposeGroup.vue?vue&type=script&lang=js"
export * from "./ComposeGroup.vue?vue&type=script&lang=js"

import "./ComposeGroup.vue?vue&type=style&index=0&id=68f0a3dd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f0a3dd"]])

export default __exports__